import * as React from "react";

import { PropertySpaceDetails as SharedUiPropertySpaceDetails } from "@shared-ui/lodging-property-offers";

import { PropertyBexApiWrapper } from "components/shared/BexApiWrapper/PropertyBexApiWrapper";
import { ComponentProps } from "typings/flexFramework/FlexComponent";

import { UitkSpacing } from "uitk-react-spacing";

const WrappedSpaceDetails = PropertyBexApiWrapper(SharedUiPropertySpaceDetails);

export const PropertySpaceDetails: React.FC<ComponentProps> = ({ context }) => (
  <section>
    <UitkSpacing margin={{ blockstart: "six" }} padding="six">
      <WrappedSpaceDetails context={context} />
    </UitkSpacing>
  </section>
);

export default PropertySpaceDetails;
